import { useTranslation } from 'react-i18next'
import { Text, Box, TooltipRenderer } from '@machobear/design-system'
import { breakpoints } from '@/styles'
import useMediaQuery from '@/hooks/use-media-query'
import LockIcon from './images/lock.svg?react'
import InfoCircleIcon from './images/info-icon.svg?react'

const TrustScoreComponent = ({ application = {} }) => {
  const { t } = useTranslation()
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.ipadMiniMax})`)
  if (application?.version === '2') {
    if (application?.trust_score?.state === 'analyzing') {
      return <Text>{t('l.listing.application.analyzing.text', 'Analyzing')}</Text>
    }
    if (application?.trust_score?.state === 'locked') {
      return (
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="flexStart"
          alignItems="center"
          gap="xsmall"
        >
          <Text size={isMobile ? 'small' : 'standard'}>
            {t('l.listing.application.locked.text', 'Locked')}
          </Text>
          <LockIcon />
        </Box>
      )
    }
    if (application?.trust_score?.status === 'not_enough_info') {
      return (
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="flexStart"
          alignItems="center"
          gap="xsmall"
        >
          <Text size={isMobile ? 'small' : 'standard'}>
            {`${application?.trust_score?.score} / ${application?.trust_score?.max_score}`}
          </Text>
          <TooltipRenderer
            tooltip={
              <Text size="small">
                {t(
                  'l.application.view.failed_hit_tooltip.label',
                  'We were unable to retrieve information from Equifax®. You can still view court records and financial documents that have been verified by the liv.rent team.'
                )}
              </Text>
            }
          >
            {({ triggerProps }) => (
              <Box
                display="flex"
                flexDirection="row"
                justifyContent="flexStart"
                alignItems="center"
                gap="xsmall"
                {...triggerProps}
              >
                <InfoCircleIcon />
              </Box>
            )}
          </TooltipRenderer>
        </Box>
      )
    }
    if (application?.trust_score?.status === 'no_credit_history') {
      return (
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="flexStart"
          alignItems="center"
          gap="xsmall"
        >
          <Text size={isMobile ? 'small' : 'standard'}>
            {`${application?.trust_score?.score} / ${application?.trust_score?.max_score}`}
          </Text>
          <TooltipRenderer
            tooltip={
              <Text size="small">
                {t(
                  'l.application.view.failed_hit_tooltip.label',
                  `This renter doesn't yet have a credit history in Canada, but we encourage you to look beyond their Canadian credit score and view financial documents that have been verified by the liv.rent team.`
                )}
              </Text>
            }
          >
            {({ triggerProps }) => (
              <Box
                display="flex"
                flexDirection="row"
                justifyContent="flexStart"
                alignItems="center"
                gap="xsmall"
                {...triggerProps}
              >
                <InfoCircleIcon />
              </Box>
            )}
          </TooltipRenderer>
        </Box>
      )
    }
    return (
      <Text
        size={isMobile ? 'small' : 'standard'}
      >{`${application?.trust_score?.score} / ${application?.trust_score?.max_score}`}</Text>
    )
  }

  if (application?.credit_rating === 'analyzing') {
    return (
      <Text size={isMobile ? 'small' : 'standard'}>
        {t('l.listing.application.analyzing.text', 'Analyzing')}
      </Text>
    )
  }
  if (application.overall) {
    return (
      <Text size={isMobile ? 'small' : 'standard'}>
        {t('l.listing.application.liv_score_count.text', {
          defaultValue: '{{ livScore }} / 100',
          livScore: application.overall
        })}
      </Text>
    )
  }

  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="flexStart"
      alignItems="center"
      gap="xsmall"
    >
      <Text size={isMobile ? 'small' : 'standard'}>
        {t('l.listing.application.locked.text', 'Locked')}
      </Text>
      <LockIcon />
    </Box>
  )
}

export default TrustScoreComponent
